import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { ConfirmationModalComponent } from '@app/partials/modal/confirmation-modal.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LucideAngularModule, ConfirmationModalComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'TVG-UI';
}
